<template>
  <v-select
    :value="value"
    :options="options"
    :reduce="(o) => o.value"
    label="text"
    :clearable="false"
    class="vselect ddi-select"
    @input="$emit('input', $event)"
  >
    <template #option="option">
      <span class="ddi-select__option">
        <span :class="flagClass(option.region)" />
        {{ option.text }}
      </span>
    </template>
    <template #selected-option="option">
      <span class="ddi-select__option">
        <span :class="flagClass(option.region)" />
        {{ compact ? `+${option.value}` : option.text }}
      </span>
    </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import "flag-icons/css/flag-icons.min.css";
import { ddiOptions } from "@/utils/phone";

// Regiões sem bandeira no pacote (ex.: Ilha de Ascensão) usam o ícone neutro.
const NO_FLAG = ["AC", "TA"];

export default {
  name: "DdiSelect",
  components: { vSelect },
  props: {
    // DDI só com dígitos, sem "+" (ex.: "55").
    value: { type: String, default: null },
    // Fechado mostra só "+55"; a lista aberta mostra "+55 · Brasil".
    compact: { type: Boolean, default: false },
  },
  computed: {
    options() {
      return ddiOptions(this.$i18n.locale);
    },
  },
  methods: {
    flagClass(region) {
      const code = region && !NO_FLAG.includes(region) ? region.toLowerCase() : "xx";
      return ["fi", `fi-${code}`];
    },
  },
};
</script>

<style scoped>
/* Mesma altura do .form-control (2.714rem no tema), para ficar lado a lado com o campo do número. */
.ddi-select ::v-deep .vs__dropdown-toggle {
  box-sizing: border-box;
  height: 2.714rem;
  padding-top: 0;
  padding-bottom: 0;
}

.ddi-select ::v-deep .vs__selected-options {
  align-items: center;
  flex-wrap: nowrap;
}

.ddi-select ::v-deep .vs__selected {
  margin-top: 0;
}

.ddi-select ::v-deep .vs__actions {
  padding-top: 0;
  padding-bottom: 0;
  align-items: center;
}

.ddi-select__option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.ddi-select__option .fi {
  flex: none;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
}
</style>
